module.exports = __webpack_public_path__ + "static/media/product_ac_pic_online_2.a72223b4.png";